import { render, staticRenderFns } from "./AddInsurancePatient.vue?vue&type=template&id=638a345f&"
import script from "./AddInsurancePatient.vue?vue&type=script&lang=js&"
export * from "./AddInsurancePatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports